import { useQuery } from 'react-query'
import { materialRequestsAPI } from '../lib/api'

// Menu, dashboard and list must observe the same request/cache and polling timer.
export function useMyMaterialRequests(user, enabled = true, poll = false) {
  return useQuery(
    ['painter-material-requests', user?.id],
    () => materialRequestsAPI.getMyRequests(),
    {
      enabled: enabled && Number(user?.role_id) === 2,
      staleTime: 30_000,
      refetchInterval: poll ? 60_000 : false,
      refetchOnWindowFocus: true,
    }
  )
}
